import { Component, Input, OnInit } from '@angular/core';
import {ModalController, NavController, NavParams} from 'ionic-angular';

import { Product, ProductFav } from '../../models/product';
import { DataProvider } from '../../providers/data';
import { AppSettings } from '../../app/app.settings';
import { TranslateService } from "@ngx-translate/core";
//import { AnalyticsService } from "../services/analytics.service";
import { Tools } from "../../tools/tools";
import { ProductDetailedPage } from "../products/product-detailed";
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {ShopsModal} from '../../modals/shops/shops';

/**
 * Generated class for the ProductsGroupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-products-group',
  templateUrl: 'products-group.html',
})
export class ProductsGroupPage implements OnInit {
  @Input() productIds: number[];
  @Input() type: string;

  public products: Product[] = [];
  public isLastProduct: boolean = false;

  public curCountry: string;

  public groupName: string = "";

  // get groupName(): string {
  //   //let zone = this.type === 'care' ? ('_' + (localStorage.getItem('es-zone') || 'face')) : '';      
  //   return ('TYPE_' + this.type /*+ zone*/).toUpperCase();
  // }  

  get currentLang() {
    let lang = localStorage.getItem('es-language') || AppSettings.DEFAULT_LANGUAGE;

    if (this.curCountry === 'uk') {
      lang = 'en';
    }
    return lang;
  }

  public isCurrentProductFav(productId: number): boolean {
    let favProds: ProductFav[] = this.dataService.getFavProducts();
    return favProds.map(p => p.id).indexOf(productId) !== -1;
  }

  // public swiperConfig: Object = {
  //     slidesPerView: 'auto',
  //     width: 680,
  //     onReachEnd: (swiper) => swiper.slideTo(0),
  //     onSlideChangeEnd: (swiper) => this.isLastProduct = swiper.activeIndex >= this.products.length - 2
  // };


  constructor(private iab: InAppBrowser,
              public navCtrl: NavController,
              public navParams: NavParams,
              private modalCtrls: ModalController,
              private dataService: DataProvider,
              private translate: TranslateService/*, private analyticsService: AnalyticsService*/) {
    this.curCountry = dataService.CURRENT_COUNTRY;
  }

  ngOnInit() {

    console.log(this.productIds);
    let group = ('TYPE_' + this.type).toUpperCase();
    let zone = '_' + (localStorage.getItem('es-zone') || '').toUpperCase();

    this.translate.get(group + zone).subscribe((res1: string) => {
      if (res1 && res1 !== group + zone) {
        this.groupName = res1;
      }
      else {
        this.translate.get(group).subscribe((res2: string) => {
          this.groupName = res2;
        });
      }
    });

    this.dataService.getProductsByIDs(this.productIds)
      .subscribe(productsData => {

        if (!AppSettings.CONFIG.show_all_volumes) {
          let groupByObj: any = Tools.groupBy(productsData, 'product_id');
          let productIDs = Object.getOwnPropertyNames(groupByObj);

          for (let productId of productIDs) {
            let sameProdVersions: Product[] = groupByObj[productId]
              .filter(v => v.volume && parseFloat(v.volume))
              .sort((p1, p2) => {
                let volume1 = parseFloat(p1.volume.replace(',', '.'));
                let volume2 = parseFloat(p2.volume.replace(',', '.'));
                if (volume1 > volume2) return 1;
                if (volume1 < volume2) return -1;
                return 0;
              });
            if (sameProdVersions.length > 1) {
              let currentVolume = sameProdVersions[0].volume;
              //console.log(sameProdVersions);                            
              for (let prodVersion of sameProdVersions) {
                if (prodVersion.volume !== currentVolume) {
                  let index = productsData.indexOf(prodVersion);
                  productsData.splice(index, 1);
                }
              }
            }
          }
        }

        this.dataService.getProductsExtByIDs(productsData.map(p => p.id)).subscribe(productsExtData => {
          for (let product of productsData) {
            let extProducts = productsExtData.filter(p => p.id === product.id);
            if (extProducts.length > 0) {
              product.productExt = extProducts[0];
            }
          }
          this.products = productsData;
        });
      });
  }

  public getProductName(currentProduct: Product): string {
    return currentProduct['name_' + this.currentLang] || currentProduct['name'] || "";
  }

  public getProductBenefits(currentProduct: Product): string[] {
    //let benefitsCount = currentProduct['benefits_' + this.currentLang + '_take'] || currentProduct['benefits_take'];
    let benefitsStr = currentProduct['benefits_' + this.currentLang] || currentProduct['benefits'] || "";
    return benefitsStr ? benefitsStr.trim().split('\n').slice(0, 3) : [];
  }

  public openDetailedProductInfo(productId: number) {
    this.navCtrl.push(ProductDetailedPage, { type: this.type, id: productId });
    //this.router.navigate(['/product', /*this.productIds.join(','),*/this.type, productId]);
  }

  public openShops(shops) {
    // const modal = this.modalCtrls.create(ShopsModal, { shops });
    //
    // modal.present();

    this.navCtrl.push(ShopsModal, { shops });
  }

  public toggleFavProduct(productId: number) {
    let favProds: ProductFav[] = this.dataService.getFavProducts();
    let currProdIndex = favProds.map(p => p.id).indexOf(productId);
    if (currProdIndex === -1) {
      favProds.push(<ProductFav>{
        id: productId,
        type: this.type
      });
    }
    else {
      favProds.splice(currProdIndex, 1);
    }
    this.dataService.setFavProducts(favProds);
  }

  public openUrl(url: any) {
    const browser = this.iab.create(url);
    browser.show();
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/products-group.ts